import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet-async";
import { OperationsMapProvider } from "./OperationsMapProvider";
import OperationsMapLayout from "./OperationsMapLayout";

export default function OperationsMapPage() {
  const { t } = useTranslation();

  return (
    <OperationsMapProvider>
      <Helmet>
        <title>Assist - {t("operationsMap:title")}</title>
      </Helmet>
      <OperationsMapLayout />
    </OperationsMapProvider>
  );
}
